<template>
  <BaseAutoCompleteWithSingleSelectedItem
    v-model="localModelValue"
    :label="i18n.global.t('pages.common.autocomplete.deviceType')"
    itemName="type"
    :items="selectableDeviceTypes"
    :initial-item-id="props.initialItemId"
    :error-messages="errorMessages"
  />
</template>
<script setup lang="ts">
import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import deviceType from '@/types/DeviceType';
import {
  visibleDeviceTypes,
  DEVICE_TYPE,
  TELTONIKA_DEVICE_TYPE,
  TELTONIKA_MAKER_ID,
} from '@/services/consts';
import { computed, onMounted } from 'vue';
import i18n from '@/lang/i18n';

const props = defineProps<{
  modelValue: deviceType | undefined;
  initialItemId?: number;
  makerId?: number;
  errorMessages?: string[];
}>();

const emit = defineEmits(['update:modelValue']);

onMounted(() => {
  if (props.initialItemId) {
    setModelValue();
  }
});

const localModelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const selectableDeviceTypes = computed(() => {
  if (props.makerId) {
    return props.makerId === TELTONIKA_MAKER_ID ? TELTONIKA_DEVICE_TYPE : DEVICE_TYPE;
  }

  return visibleDeviceTypes;
})

function setModelValue() {
  if (props.initialItemId) {
    localModelValue.value = visibleDeviceTypes.filter((item) => {
      return item.id === props.initialItemId
    })[0];
  }
}
</script>
